// src/services/storageService.js

export const uploadFileApi = async ({ 
  customerName, 
  simulationName, 
  datasetName, 
  token, 
  fileContent 
}) => {
  const url = `${process.env.REACT_APP_BASE_URL}/storage_manager/input_csv?storage_account=${customerName}&microgrid_name=${simulationName}&dataset_name=${datasetName}`;

  const headers = {
    "Content-Type": "text/csv",
    "x-output-storage-manager-type":
      process.env.REACT_APP_UPLOAD_FILES_STORAGE_MANAGER_TYPE,
    Authorization: `Bearer ${token}`,
    "X-User-ID": sessionStorage.getItem("UserID") || "",
  };

  const response = await fetch(url, {
    method: "POST",
    headers,
    body: fileContent,
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    if (errorResponse.message?.includes("time data")) {
      return {
        type: "error",
        text: 'The date format in the file does not match the expected format "%m/%d/%Y %H:%M". Please correct the file and try again.',
      };
    }
    return {
      type: "error",
      text: ` ${errorResponse.message || "Upload failed"}`,
    };
  }

  return { type: "success", text: "File uploaded successfully." };
};
